import axios from 'axios'
import CONSTS from '@const/plugin.constants'

export default () => {
    return axios.create({
      baseURL: CONSTS.API_URL,
      withCredentials: false,
      headers: {
        'Content-Type': 'application/json'
      },
    })
}
